import moment from "moment";

const dateUtils = {
  formatDateForDisplay: (dateString) =>
    moment(dateString, "YYYY-MM-DD", true).isValid()
      ? moment(dateString, "YYYY-MM-DD").format("DD/MM/YYYY")
      : "",

  formatDateForInput: (dateString) =>
    moment(dateString, ["DD/MM/YYYY", "YYYY-MM-DD"], true).isValid()
      ? moment(dateString, ["DD/MM/YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD")
      : "",
};

export default dateUtils;
